module.exports = __webpack_public_path__ + "static/media/ES-Ub.47a9105a.png";